export const getShortName = (name: string, length: number) => {
  const lowerCaseName = name.toLowerCase().replace(/\s+/g, '_')
  let updatedName = lowerCaseName
  if (updatedName.length > length) {
    updatedName = lowerCaseName.substring(0, length)
  }
  return updatedName
}

export const getShortNameV2 = (name: string, length: number) => {
  if (name.length > length) {
    return name.substring(0, length) + '...'
  }
  return name
}
